import { useEffect, useState } from 'preact/hooks';
import { detectOS, redirectToStore, APP_STORE_URL, PLAY_STORE_URL } from '../../utils/appStore';
import styles from '../../styles/AppRedirect.module.css';
import logoImage from '../../assets/images/logo.png';
import textLogoImage from '../../assets/images/olym_text_logo.png';

export default function AppRedirect({
  title = '앱으로 이동 중...',
  subtitle = '잠시만 기다려주세요',
  redirectingTitle = '앱스토어로 이동합니다',
  redirectingSubtitle = '앱을 설치해주세요',
  delay = 1500
}) {
  const [status, setStatus] = useState('loading');
  const os = detectOS();

  useEffect(() => {
    const timer = setTimeout(() => {
      const redirected = redirectToStore(os);
      if (redirected) {
        setStatus('redirecting');
      } else {
        setStatus('desktop');
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [os, delay]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={logoImage} alt="olym" className={styles.logoImage} />
          <img src={textLogoImage} alt="olym" className={styles.textLogoImage} />
        </div>

        {status === 'loading' && (
          <>
            <div className={styles.spinner} />
            <p className={styles.message}>{title}</p>
            <p className={styles.subMessage}>{subtitle}</p>
          </>
        )}

        {status === 'redirecting' && (
          <>
            <p className={styles.message}>{redirectingTitle}</p>
            <p className={styles.subMessage}>{redirectingSubtitle}</p>
          </>
        )}

        {status === 'desktop' && (
          <>
            <p className={styles.message}>모바일에서 접속해주세요</p>
            <p className={styles.subMessage}>olym 앱은 모바일에서만 이용 가능합니다</p>
            <div className={styles.storeButtons}>
              <a href={APP_STORE_URL} className={styles.storeButton} target="_blank" rel="noopener noreferrer">
                App Store
              </a>
              <a href={PLAY_STORE_URL} className={styles.storeButton} target="_blank" rel="noopener noreferrer">
                Google Play
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
